import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ZorroTableComponent } from '../common/custom-table/zorro-table.component';

@Component({
  selector: 'app-table-with-header',
  standalone: true,
  imports: [CommonModule, ZorroTableComponent, FormsModule],
  templateUrl: './table-with-header.component.html',
  styleUrl: './table-with-header.component.scss'
})
export class TableWithHeaderComponent {

  @Input() projectId!: string;
  @Input() headerType: string = 'paginationDetails';
  @Input() meta: any = {};
  @Input() columns: any = [];
  @Input() rows: any = [];
  @Input() viewId: string = '';
  @Input() showProgressBar: boolean = false;          // Show progress bar in header
  @Input() progressBarLabel: string = 'Overall Code Coverage';  // Label for progress bar
  @Input() progressBarValue: number = 0;              // Progress bar percentage (0-100)
  @Output() highImpactSaveClick = new EventEmitter<any>();
  @Input() isHighImpactSaveLoading: boolean = false; 
  @Input() showSaveButton: boolean = false;          

  @Output() onComponentAction = new EventEmitter();

  tablePage = 1;
  tablePageSize = this.meta?.table?.options?.pageSize || 10;

  get tablePaginationLabel(): string {
    const total = this.rows.length;
    const from = (this.tablePage - 1) * this.tablePageSize + 1;
    const to = Math.min(this.tablePage * this.tablePageSize, total);
    return `${this.meta?.paginationPrefix || 'Showing'} <strong>${from}</strong> to <strong>${to}</strong> of <strong>${total}</strong>`;
  }

  ngOnInit() {
    console.log(this.rows);
  }

  onReclaim() {
    this.onTableAction({ actionKey: 'reclaimEngine' });
  }

  onTableAction(event: any) {
    this.onComponentAction.emit(event);
  }

  onTablePageChange(event: { page: number; size: number }) {
    this.tablePage = event.page;
    this.tablePageSize = event.size ?? this.tablePageSize;
  }

  onHighImpactSave(){
    this.highImpactSaveClick.emit({
      rows:this.rows
    });
  }
}
